export enum DealResponseCodes {
  NO_ACTIVE_DEAL = 404005,
  ACCESS_CODE_DENIED = 403201,
  EXPIRED_DEAL = 400401,
  INVALID_DEAL_STATUS = 400413,
}
